export enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

interface LogEntry {
  level: LogLevel;
  data: any;
}

class Logger {
  private static instance: Logger;
  private logs: { [key: string]: LogEntry } = {};

  // private constructor() {}

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  public log(key: string, level: LogLevel, data: any) {
    this.logs[key] = { level, data };
  }

  public getLogs(): { [key: string]: LogEntry } {
    return this.logs;
  }

  public clearLogs() {
    this.logs = {};
  }
}

export default Logger;